const MIXED_BOARD_LABEL = "בסיסי אירוח שונים";

export const CANCELLATION_FILTERS = Object.freeze([
  { id: "free", label: "ביטול ללא עלות" },
  { id: "refundable", label: "ניתן לביטול" },
  { id: "nonrefundable", label: "לא ניתן לביטול" },
  { id: "mixed", label: "תנאים שונים בין החדרים" },
  { id: "other", label: "לפי תנאי הספק" },
]);

function uniqueSorted(values) {
  return [...new Set(values.filter(Boolean))].sort((a, b) =>
    a.localeCompare(b, "he")
  );
}

export function roomBoardLabels(room) {
  const combo = Array.isArray(room?.combinationRooms) ? room.combinationRooms : [];
  const fromCombo = combo
    .map((item) => String(item?.boardLabel || "").trim())
    .filter((label) => label && label !== MIXED_BOARD_LABEL);
  if (fromCombo.length) return uniqueSorted(fromCombo);
  const one = String(room?.boardLabel || room?.boardSummary || "").trim();
  if (!one || one === MIXED_BOARD_LABEL) return [];
  return [one];
}

export function roomTypeLabels(room) {
  const combo = Array.isArray(room?.combinationRooms) ? room.combinationRooms : [];
  if (combo.length > 1) {
    return uniqueSorted(combo.map((item) => String(item?.name || "").trim()));
  }
  const name = String(room?.name || "").trim();
  return name ? [name] : [];
}

export function cancellationFilterKey(room) {
  if (!room) return null;
  if (room.cancellationMixed) return "mixed";
  const label = String(room.cancellationSummary || "").trim();
  const type = String(room.cancellation?.type || "").toLowerCase();
  if (
    room.cancellationFree ||
    label.startsWith("ביטול ללא עלות") ||
    label.startsWith("ביטול חינם")
  ) {
    return "free";
  }
  if (
    label === "לא ניתן לביטול" ||
    (type.includes("non") && type.includes("refund"))
  ) {
    return "nonrefundable";
  }
  if (
    label === "ניתן לביטול" ||
    (type.includes("refund") && !type.includes("non"))
  ) {
    return "refundable";
  }
  return label ? "other" : null;
}

export function collectBoardFilterOptions(rooms) {
  return uniqueSorted((rooms || []).flatMap((room) => roomBoardLabels(room))).map(
    (label) => ({ id: label, label })
  );
}

export function collectRoomTypeFilterOptions(rooms) {
  return uniqueSorted((rooms || []).flatMap((room) => roomTypeLabels(room))).map(
    (label) => ({ id: label, label })
  );
}

export function collectCancellationFilterOptions(rooms) {
  const present = new Set(
    (rooms || []).map((room) => cancellationFilterKey(room)).filter(Boolean)
  );
  return CANCELLATION_FILTERS.filter((option) => present.has(option.id));
}

function matchesAny(values, selected) {
  if (!selected?.length) return true;
  if (!values?.length) return false;
  return values.some((value) => selected.includes(value));
}

export function roomMatchesSelectionFilters(room, filters = {}) {
  const boards = filters.boards || [];
  const cancellations = filters.cancellations || [];
  const roomTypes = filters.roomTypes || [];
  if (!matchesAny(roomBoardLabels(room), boards)) return false;
  if (cancellations.length) {
    const key = cancellationFilterKey(room);
    if (!key || !cancellations.includes(key)) return false;
  }
  if (!matchesAny(roomTypeLabels(room), roomTypes)) return false;
  return true;
}
